module.exports = __webpack_public_path__ + "img/example_southern_north_sea_r1.a7714188.jpg";